export const GUTTER_WIDTH = 20;

export const MARGIN_BIG = 30;
